const COMPLETED = 'COMPLETED'
const ACCEPTED = 'ACCEPTED'
const RESUMED = 'RESUMED'
const REJECTED = 'REJECTED'
const FAILED = 'FAILED'
const TIMED_OUT = 'TIMED_OUT'

export default {
  COMPLETED,
  ACCEPTED,
  RESUMED,
  REJECTED,
  FAILED,
  TIMED_OUT
}
